<template>
  <div class="tw-relative">
    <button
      class="tw-flex tw-cursor-pointer tw-justify-center tw-items-center tw-gap-3 tw-text-lg tw-bg-[#F1583D] tw-text-white tw-rounded-lg tw-py-4 tw-border-none tw-font-inter tw-font-semibold tw-w-full"
      @click="goToExportPage"
    >
      <span>Export</span>
      <i class="fa fa-external-link-alt" />
    </button>

    <div
      class="tw-absolute tw-flex tw-flex-col tw-gap-3 tw-text-slate-800"
    >
    </div>
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  components: { },
  computed: {
    ...mapStores(useCheckupStore),
  },
  methods: {
    goToExportPage() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.checkupStore.setActiveArea('Export');
    },
  },
};
</script>
